"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_use_1 = require("react-use");
const react_1 = require("react");
exports.useOsmosysSlingshot = (ms, onValue, offValue) => {
    const [on, toggle] = react_use_1.useToggle(false);
    const trigger = react_1.useCallback(() => {
        toggle(true);
        const t = setTimeout(() => {
            toggle(false);
        }, ms);
        return () => {
            clearTimeout(t);
        };
    }, [toggle]);
    return [on ? onValue : offValue, trigger];
};
//# sourceMappingURL=useOsmosysSlingshot.js.map